'use strict';

module.exports = true;